import React, { useEffect } from 'react';
import './FrequencyOverlay.scss';
import { Button, EButtonType, EInputType, Input, KitIcons } from '@repo/apg-ui';
import { FormattedMessage, useIntl } from 'react-intl';
import classNames from 'classnames';

interface Props {
  frequencyLabels?: string;
  placeholderText?: string;
  inputValue: any;
  onChange?: any;
  extraClassName?: string;
  isDisabled?: boolean;
  isFromHeader?: boolean;
}

export const FrequencyOverlay = ({
  placeholderText,
  frequencyLabels,
  inputValue,
  onChange,
  extraClassName,
  isDisabled,
  isFromHeader = false,
}: Props) => {
  const intl = useIntl();
  const [frequency, setFrequency] = React.useState<string>(inputValue.toString() || '0:00');

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      setFrequency(event.target.value || '0:00');
      onChange(event.target.value || '0:00');
    }
  };

  const handleChange = (name, value) => {
    setFrequency(value);
  };

  if (isDisabled) return null;

  return (
    <div
      className={classNames(`overlay-content frequency-block ${extraClassName}`, {
        'header-frequency': isFromHeader,
      })}
      id='root'
    >
      <div className='d-flex align-items-start justify-content-start gap-3 w-100'>
        <div className='d-flex flex-column position-relative align-items-start justify-content-start'>
          <div className='subtitle'>{frequencyLabels || 'Price'}</div>
          <div className='d-flex align-items-center justify-content-center gap-3'>
            <div className='input-wrap'>
              {isFromHeader && (
                <span className='input-label-prefix'>
                  <FormattedMessage id='ec.checkout.all' defaultMessage='Alle' />
                </span>
              )}
              <Input
                name='frequency'
                inputType={EInputType.Text}
                label={
                  placeholderText ||
                  intl.formatMessage({
                    id: 'ec.checkout.frequency',
                    defaultMessage: 'Frequenz',
                  })
                }
                type='text'
                placeholder='0:00'
                inputWrapperClass='modal-input-text'
                onChange={(name, value) => handleChange(name, value)}
                onFocus={(event: any) => event.target.select()}
                isFocused={true}
                value={frequency}
                onKeyDown={handleKeyDown}
              />
              <span className='input-label'>
                <FormattedMessage id='ec.checkout.minutes' defaultMessage='Minuten' />
              </span>
            </div>
            <div className='input-action'>
              <Button
                buttonType={EButtonType.PillSmall}
                onClick={() => {
                  let val = frequency;
                  if (val && !val.includes(':')) {
                    val = `${frequency}:00`;
                  }
                  if (!val) {
                    val = '0:00';
                  }
                  setFrequency(val);
                  onChange(val);
                }}
              >
                <div className='button-svg'>
                  <KitIcons.CheckIcon className='check-svg' />
                </div>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
